import {
  add,
  clone,
  format,
  isAfter,
  isBetween,
  now,
  parseFormat,
  subtract,
} from 'app/lib/date'
import * as helpers from 'app/sm/helpers'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'

export const SMS_REPORT_HELP_TEXT =
  'SMS report scheduled to send within 30m of finish'

export const startToEndTimeIntervalsFromHours = (
  startTime,
  endTime,
  duration,
) => {
  let timeIntervalsArray = []
  let beginning = now().hour(startTime).minute(0).second(0)
  const end = now().hour(endTime).minute(0).second(0)

  while (beginning.diff(end) < 0) {
    // TODO: Remove this condition!
    // Use clone() rather than parse() — adapter parse() returns the same
    // moment instance, which would mutate `beginning` through the .hour call.
    if (beginning > clone(beginning).hour(startTime)) {
      timeIntervalsArray.push(format(beginning, 'h:mm A'))
    }
    beginning = add(beginning, duration, 'minutes')
  }
  return timeIntervalsArray
}

export const requestViewingDateFormat = 'D MMM YYYY (ddd)'

export const oneDayLaterErrorMessage =
  'Choose a date within the past 24 hrs or later'
export const conflictingTimeMessage =
  'A time already exists for this property or team member, schedule anyway?'

export const VIEWING_REPORT_CONFIRMATION_MESSAGE =
  'The viewing is not finished. Are you sure you want to send the Report?'
export const SMS_VIEWING_REPORT_CONFIRMATION_MESSAGE =
  'The viewing is not finished. Are you sure you want to send the SMS Report?'

export const VIEWING_TIME_DATE_ERROR =
  'Please check if the viewing time and date are valid'

export const CANCEL_VIEWING_CONFIRM_TEXT =
  'Are you sure you want to cancel the viewing? Registrants and enquirers will be notified.'
export const CANCEL_VIEWING_CONFIRMATION_MESSAGE =
  'Viewing cancelled, notification for registrants and enquirers requested.'

export const TIME_PAST_ERROR = 'Time Past'

export const isfutureViewing = (startDate) => {
  return isAfter(startDate, now())
}

export const calcEndDateFromStartDateAndDuration = (startDate, duration) => {
  return add(startDate, duration, 'minutes')
}

export const isViewingInProgress = (startDate, endDate) => {
  // Preserve upstream missing-return behaviour; see helpers.test.js.
  isBetween(now(), startDate, endDate)
}

export const checkIfViewingEnded = (viewing) => {
  const { startDate, duration } = viewing || {}
  if (startDate && duration) {
    return isAfter(now(), add(startDate, duration, 'minutes'))
  }
  return false
}
export const StatusAttendeeUndefined = 0
export const StatusAttendeeConfirmed = 1
export const StatusAttendeeCancelled = 2
export const SelfCheckInTypeUndefined = ''
export const SelfCheckInTypeQR = 'QR'

export function ValidateDateWithOnedayPastDate(
  date1,
  date2,
  emptyMessage,
  message,
) {
  const datePastOneDay = format(
    subtract(now(), 1, 'days'),
    helpers.dateWithDash,
  )
  const errors = []
  if (!date1 || date1 === '') {
    errors.push(emptyMessage)
  } else if (!date2 || date2 === '') {
    errors.push(emptyMessage)
  } else if (datePastOneDay > date2) {
    errors.push(message)
  }

  return errors
}

export function validateViewingStartTime(selectedDate, startTime, message) {
  let errors = []

  if (!startTime) {
    errors.push(message)

    return errors
  }

  let currentDate = format(now(), 'DD MMM YYYY')
  if (selectedDate) {
    currentDate = selectedDate
  }

  const selectedStartDate = `${currentDate} ${startTime}`
  const twentyFourHoursAgo = format(
    subtract(now(), 24, 'hours'),
    'DD MMM YYYY hh:mm A',
  )
  if (
    parseFormat(selectedStartDate, 'DD MMM YYYY hh:mm A').isBefore(
      parseFormat(twentyFourHoursAgo, 'DD MMM YYYY hh:mm A'),
      'second',
    )
  ) {
    errors.push(message)
  }

  return errors
}

export const VIEWINGS_BY_PROPERTY = 'viewingsByProperty'
export const VIEWINGS_BY_DATE = 'viewingsByDate'

export const SORT_BY_DATE = 'date'
export const SORT_BY_ADDRESS = 'address'

export const viewingCutoffOptions = [
  { guid: 0, name: 'Next day' },
  { guid: 1, name: '2 Hours' },
  { guid: 2, name: '4 Hours' },
]

export const showSMSReportStatusAndType = (
  viewingTimeStart,
  viewingTimeEnd,
  isSMSViewingReportSent,
) => {
  let showReportAndStatus = {
    showStatusPill: false,
    statusPillText: 'Not Sent',
    statusPillVariant: 'warning',
  }
  if (isSMSViewingReportSent) {
    showReportAndStatus = {
      showStatusPill: true,
      statusPillText: 'Sent',
      statusPillVariant: 'success',
    }
    return showReportAndStatus
  }
  const currentTime = format(now(), dateTimeHelpers.DEFAULT_UNIX_TIME_Z)
  const startTime = format(
    viewingTimeStart,
    dateTimeHelpers.DEFAULT_UNIX_TIME_Z,
  )
  const endTime = format(viewingTimeEnd, dateTimeHelpers.DEFAULT_UNIX_TIME_Z)
  if (isBetween(currentTime, startTime, endTime)) {
    showReportAndStatus = {
      showStatusPill: true,
      statusPillText: 'Pending',
      statusPillVariant: 'warning',
    }
    return showReportAndStatus
  }
  if (isAfter(currentTime, viewingTimeEnd)) {
    showReportAndStatus = {
      showStatusPill: true,
      statusPillText: 'Not Sent',
      statusPillVariant: 'warning',
    }
  }
  return showReportAndStatus
}

export const checkIfViewingSlotIsEnabled = (registrants) => {
  return registrants.some((registrant) => registrant.slot > 0)
}

export const orderRegistrantsBasedOnSlots = (registrants) => {
  const filteredRegistrantsWithNoSlots = registrants.filter(
    (registrant) => registrant.slot === 0,
  )
  const filteredRegistrantsWithSlots = registrants.filter(
    (registrant) => registrant.slot !== 0,
  )

  let slotOrderedRegistrants = filteredRegistrantsWithSlots.sort(
    (regA, regB) => {
      return regA.slot - regB.slot
    },
  )
  slotOrderedRegistrants = slotOrderedRegistrants.concat(
    filteredRegistrantsWithNoSlots,
  )
  return slotOrderedRegistrants
}

export const VIEWING_RUN_DRAFT = 'draft'
export const VIEWING_RUN_PUBLISHED = 'published'

export const isViewingRunDraft = (status) => {
  return status === VIEWING_RUN_DRAFT
}

export const isActiveRegistrant = (registrant = {}) => {
  const confirmationStatus =
    registrant?.viewingOnsiteRegistrant?.confirmationStatus || 0
  return confirmationStatus !== StatusAttendeeCancelled
}
